import React from "react";
import { Link as RouterLink, type LinkProps } from "react-router-dom";
import MuiLink, { type LinkProps as MuiLinkProps } from "@mui/material/Link";
import type { SxProps, Theme } from "@mui/material/styles";

type AuthPageLinkProps = LinkProps & {
  sx?: SxProps<Theme>;
};

/**
 * Lien des pages auth / reset : fort contraste sur fond sombre (primary.light trop sombre sur noir).
 */
export const AuthPageLink: React.FC<AuthPageLinkProps> = ({
  sx: sxProp,
  ...rest
}) => {
  const baseSx: SxProps<Theme> = (theme) => ({
    fontWeight: 500,
    textUnderlineOffset: "3px",
    ...(theme.palette.mode === "dark"
      ? {
          color: theme.palette.grey[100],
          "&:hover": {
            color: theme.palette.common.white,
          },
          "&:focus-visible": {
            color: theme.palette.common.white,
            outline: `2px solid ${theme.palette.secondary.light}`,
            outlineOffset: 2,
          },
        }
      : {
          color: theme.palette.primary.main,
          "&:hover": {
            color: theme.palette.primary.dark,
          },
        }),
  });

  return (
    <MuiLink
      component={RouterLink}
      underline="always"
      {...(rest as MuiLinkProps<typeof RouterLink>)}
      sx={Array.isArray(sxProp) ? [baseSx, ...sxProp] : [baseSx, sxProp]}
    />
  );
};
